import React, { useState } from "react";
import s from "./style.module.css";
import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const Close = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#fff"
    >
      <path
        d="M15.857.143a.49.49 0 01.056.625l-.056.068L8.693 8l7.164 7.164a.49.49 0 01-.625.75l-.068-.057L8 8.693.836 15.857a.49.49 0 01-.75-.625l.057-.068L7.307 8 .143.836a.49.49 0 01.625-.75l.068.057L8 7.307 15.164.143a.49.49 0 01.693 0z"
        fill-rule="evenodd"
      />
    </svg>
  </svg>
);

const Modal = ({ children, openText = "Open me!" }) => {
  const [isOpen, openModal] = useState(false);
  return (
    <div>
      <button className={s.openButton} onClick={() => openModal(true)}>
        {openText}
      </button>
      <ReactModal
        closeTimeoutMS={300}
        isOpen={isOpen}
        className={s.modal}
        shouldCloseOnOverlayClick
      >
        <div className={s.close}>
          <button className={s.closeButton} onClick={() => openModal(false)}>
            <Close />
          </button>
        </div>

        <div className={s.modalInner}>{children}</div>
      </ReactModal>
    </div>
  );
};

export default Modal;
